module.exports = __webpack_public_path__ + "static/media/sack.ea2d7559.svg";